export default __webpack_public_path__ + "static/media/mohamed-ibrahim-b.35f864be.jpeg";